<template>
  <div class="header">
    <div class="bg"></div>
    <fda-step-items :active="active" direction="horizontal" @click-step-item="stepItemClick">
      <fda-step-item title="服务机构" />
      <fda-step-item title="医生团队" />
      <fda-step-item title="服务包" />
    </fda-step-items>
  </div>
  <router-view v-slot="{ Component }" name="select-contract">
    <keep-alive :include="keepAliveRoutes" :exclude="excludeRoutes">
      <component :is="Component" />
    </keep-alive>
  </router-view>
</template>
<script lang="ts">
export default {
  name: 'SelectContractLayout',
};
</script>
<script setup lang="ts">
import { router } from '@/router';
import { onBeforeRouteLeave } from 'vue-router';
import { keepAliveRoutes, excludeRoutes, addRouteToExclude, recoverKeepAlive } from '@/router/routes';

// const active = ref<number>(1);
// active.value = currentRoute.value.meta.step as number;
const { currentRoute } = useRouter();
const active = computed(() => {
  return Number(currentRoute.value.meta.step);
});
const stepItemClick = (index) => {
  console.log('cur-step-item:: ', index);
  return;
  if (index === 0) {
    router.push({ name: 'contract-service' });
  }
  if (index === 1) {
    router.push({ name: 'contract-doctorteam' });
  }
  if (index === 2) {
    router.push({ name: 'contract-package' });
  }
};
const ins = getCurrentInstance();
onBeforeRouteLeave((to) => {
  if (!['contract-index', 'agreement-page'].includes(String(to.name))) {
    addRouteToExclude(String(ins?.type.name));
  } else {
    recoverKeepAlive(String(ins?.type.name));
  }
});
</script>

<style lang="less" scoped>
.header {
  overflow: hidden;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
  height: 126px;
  background: #fff;
}

#app .bg {
  position: absolute;
  left: 0;
  right: 0;
  top: -176px;
  z-index: 1;
  height: 440px;

  // background: linear-gradient(180deg, #dfecfc 60.04%, #f2f5fa 94.74%, #f4f6fa 94.74%);
  background: linear-gradient(180deg, #e0edfc 0%, rgba(255, 255, 255, 0%) 100%);
}

.fda-step-items {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9;
}
</style>
